import { ModalTitle, ModalWrapper } from '@anm/components/stream/destination_management/ConnectToFacebookModal/Wrapper';
import AccountList from '@anm/components/stream/destination_management/DestinationAccountList/AccountList';
import capitalize from '@anm/helpers/string/capitalize';
import { FC } from 'react';
import { DestinationList, StreamingNetwork } from 'types/stream';

import useConnectDestinations from '../hooks/useConnectDestinations';
import { DestinationTypes } from '../types';

import { Disclaimer, ModalBodyWrapper, ModalLoader } from './Wrapper';

type ChooseAccountModalProps = {
  destinations: DestinationList;
  network: StreamingNetwork;
  onModalClose: () => void;
  destinationType?: DestinationTypes;
};

const ChooseAccountModal: FC<ChooseAccountModalProps> = ({
  network,
  destinations,
  destinationType = 'page',
  onModalClose
}) => {
  const capitalizedNetwork = capitalize(network, true);
  const lowercaseNetwork = network.toLowerCase();

  const [onConnect, isPending] = useConnectDestinations(onModalClose);
  const modalTitle = `Choose a ${capitalizedNetwork} ${capitalize(destinationType)}`;

  return (
    <ModalWrapper onModalClose={onModalClose}>
      <ModalTitle title={modalTitle} />
      <>
        {isPending ? (
          <ModalLoader size="medium" color="blue" />
        ) : (
          <>
            <ModalBodyWrapper>
              <AccountList list={destinations.map(d => ({ ...d, isChecked: false }))} onSelectDestination={onConnect} />
            </ModalBodyWrapper>
            <Disclaimer>
              Needed account not listed?{' '}
              <a href={`https://www.${lowercaseNetwork}.com/`} target="_blank">
                Log in to {capitalizedNetwork}
              </a>
            </Disclaimer>
          </>
        )}
      </>
    </ModalWrapper>
  );
};

export default ChooseAccountModal;
